/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { c as createCommonjsModule, g as getAugmentedNamespace, a as getDefaultExportFromCjs } from './_commonjsHelpers-56d33373.js';
import { f as es } from './index-892d8eee.js';

var promisify_2 = promisify;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }
          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }
          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }
          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }
          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var promisify_1 = /*#__PURE__*/Object.defineProperty({
	promisify: promisify_2
}, '__esModule', {value: true});

var styleOptions = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.styleOut = exports.styleIn = void 0;
var _excluded = ["_ext"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var styleOut = function styleOut(output, originalInput, originalOutput) {
  return _extends({}, output, {
    _original: {
      input: _extends({}, originalInput),
      // 实际调用 api 方法时传入的参数. 对入参进行 format 之后的结果
      output: _extends({}, originalOutput) // 实际调用 api 方法时传入的参数. 返回值 format 之前的结果
    }
  });
};
exports.styleOut = styleOut;
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
    _ref$_ext = _ref._ext,
    _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return _extends({}, rest, _ext[baseName] || {});
};
exports.styleIn = styleIn;
});

var common = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.formatSystemInfoAsync = exports.formatSystemInfo = exports.formatResult = void 0;


function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var formatLanguage = function formatLanguage(language) {
  var fl = 'en';
  switch (language.toLowerCase()) {
    case 'zh_cn':
    case 'zh-hans':
    case 'zh-cn':
    case 'chinese':
      fl = 'zh_CN';
      break;
    case 'zh_tw':
    case 'zh-hant':
    case 'zh-hk':
      fl = 'zh_TW';
      break;
    case 'en':
    case 'english':
    case 'en-us':
      fl = 'en';
      break;
    default:
      fl = 'en';
  }
  return fl;
};
var formatSystemInfo = function formatSystemInfo(api) {
  return function () {
    var res = api();
    return formatResult(res);
  };
};
exports.formatSystemInfo = formatSystemInfo;
var formatResult = function formatResult(data) {
  var defaultData = {
    pixelRatio: 1,
    screenWidth: 0,
    screenHeight: 0,
    windowWidth: 0,
    windowHeight: 0,
    language: '',
    version: '',
    platform: ''
  };
  return _extends({}, defaultData, data, {
    language: data.language ? formatLanguage(data.language) : ''
  });
};
exports.formatResult = formatResult;
var formatSystemInfoAsync = function formatSystemInfoAsync(api, containerName) {
  return function (options) {
    var _options = (0, styleOptions.styleIn)(options, containerName);
    var afterOptions = _extends({}, _options, {
      success: function success(res) {
        _options.success && _options.success(formatResult(res));
      },
      complete: function complete(res) {
        _options.complete && _options.complete(res.pixelRatio ? formatResult(res) : res);
      }
    });
    return (0, promisify_1.promisify)(api)(afterOptions).then(formatResult);
  };
};
exports.formatSystemInfoAsync = formatSystemInfoAsync;
});

var constant = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.JSONP_SIGN = exports.CONTAINER_NAME = void 0;
var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};
exports.CONTAINER_NAME = CONTAINER_NAME;
var JSONP_SIGN = '__uni_jsonp_handler_sign__';
exports.JSONP_SIGN = JSONP_SIGN;
});

var getInfo_1$5 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


function getPlatform() {
  var _navigator = navigator,
    platform = _navigator.platform;
  if (platform) {
    var _navigator2, _navigator2$userAgent, _navigator3, _navigator3$userAgent;
    if (/(iphone|ipod|ipad)/.test((_navigator2 = navigator) == null ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) == null ? void 0 : _navigator2$userAgent.toLowerCase())) return 'iOS';
    if (/android/.test((_navigator3 = navigator) == null ? void 0 : (_navigator3$userAgent = _navigator3.userAgent) == null ? void 0 : _navigator3$userAgent.toLowerCase())) return 'Android';
    return platform;
  }
  return '';
}
var getInfoSync = (0, common.formatSystemInfo)(function () {
  return {
    pixelRatio: window.devicePixelRatio,
    screenWidth: window.document.documentElement.clientWidth,
    screenHeight: window.document.documentElement.clientHeight,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    language: navigator.language,
    version: navigator.appVersion,
    platform: getPlatform() || ''
  };
});
var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var success = options.success,
    fail = options.fail,
    complete = options.complete;
  try {
    var res = getInfoSync();
    success && success(res);
    complete && complete(res);
  } catch (e) {
    fail && fail(e);
    complete && complete(e);
  }
}, constant.CONTAINER_NAME.WEB);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1$5 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

function getPlatform() {
  var _navigator = navigator,
    platform = _navigator.platform;
  if (platform) {
    var _navigator2, _navigator2$userAgent, _navigator3, _navigator3$userAgent;
    if (/(iphone|ipod|ipad)/.test((_navigator2 = navigator) == null ? void 0 : (_navigator2$userAgent = _navigator2.userAgent) == null ? void 0 : _navigator2$userAgent.toLowerCase())) return 'iOS';
    if (/android/.test((_navigator3 = navigator) == null ? void 0 : (_navigator3$userAgent = _navigator3.userAgent) == null ? void 0 : _navigator3$userAgent.toLowerCase())) return 'Android';
    return platform;
  }
  return '';
}
var getInfoSync = (0, common.formatSystemInfo)(function () {
  return {
    pixelRatio: window.devicePixelRatio,
    screenWidth: window.document.documentElement.clientWidth,
    screenHeight: window.document.documentElement.clientHeight,
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    language: navigator.language,
    version: navigator.appVersion,
    platform: getPlatform()
  };
});
var _default = getInfoSync;
exports.default = _default;
});

var web = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1$5);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1$5);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var miniappEnvApp = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.isDingdingMiniapp = void 0;
function isUndef(type) {
  return type === 'undefined';
}
var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);
exports.isDingdingMiniapp = isDingdingMiniapp;
});

var getInfo_1$4 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;



var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  var _getInfo = miniappEnvApp.isDingdingMiniapp ? dd.getSystemInfo : my.getSystemInfo;
  _getInfo({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, constant.CONTAINER_NAME.ALIPAY);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1$4 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


var getInfoSync = (0, common.formatSystemInfo)(function () {
  return miniappEnvApp.isDingdingMiniapp ? dd.getSystemInfoSync() : my.getSystemInfoSync();
});
var _default = getInfoSync;
exports.default = _default;
});

var aliMiniapp = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1$4);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1$4);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var getInfo_1$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  wx.getSystemInfo({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, constant.CONTAINER_NAME.WECHAT);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1$3 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var getInfoSync = (0, common.formatSystemInfo)(function () {
  return wx.getSystemInfoSync();
});
var _default = getInfoSync;
exports.default = _default;
});

var wechatMiniprogram = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1$3);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1$3);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var getInfo_1$2 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  tt.getSystemInfo({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, constant.CONTAINER_NAME.BYTE);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1$2 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var getInfoSync = (0, common.formatSystemInfo)(function () {
  return tt.getSystemInfoSync();
});
var _default = getInfoSync;
exports.default = _default;
});

var bytedanceMicroapp = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1$2);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1$2);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var getInfo_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  ks.getSystemInfo({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, constant.CONTAINER_NAME.KWAI);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1$1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var getInfoSync = (0, common.formatSystemInfo)(function () {
  return ks.getSystemInfoSync();
});
var _default = getInfoSync;
exports.default = _default;
});

var kuaishouMiniprogram = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1$1);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1$1);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var getInfo_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;


var getInfo = (0, common.formatSystemInfoAsync)(function (options) {
  var _success = options.success,
    _fail = options.fail,
    _complete = options.complete;
  swan.getSystemInfo({
    success: function success(res) {
      _success && _success(res);
    },
    fail: function fail(res) {
      _fail && _fail(res);
    },
    complete: function complete(res) {
      _complete && _complete(res);
    }
  });
}, constant.CONTAINER_NAME.BAIDU);
var _default = getInfo;
exports.default = _default;
});

var getInfoSync_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;

var getInfoSync = (0, common.formatSystemInfo)(function () {
  return swan.getSystemInfoSync();
});
var _default = getInfoSync;
exports.default = _default;
});

var baiduSmartprogram = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.default = void 0;
var _getInfo = _interopRequireDefault(getInfo_1);
exports.getInfo = _getInfo.default;
var _getInfoSync = _interopRequireDefault(getInfoSync_1);
exports.getInfoSync = _getInfoSync.default;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = {
  getInfo: _getInfo.default,
  getInfoSync: _getInfoSync.default
};
exports.default = _default;
});

var _env = /*@__PURE__*/getAugmentedNamespace(es);

var lib = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports.getInfoSync = exports.getInfo = exports.default = void 0;

var webModule = _interopRequireWildcard(web);
var aliMiniAppModule = _interopRequireWildcard(aliMiniapp);
var weChatModule = _interopRequireWildcard(wechatMiniprogram);
var bytedanceModule = _interopRequireWildcard(bytedanceMicroapp);
var kuaiShouModule = _interopRequireWildcard(kuaishouMiniprogram);
var baiDuModule = _interopRequireWildcard(baiduSmartprogram);
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getInfoSync = function getInfoSync() {
  if (_env.isWeb) {
    return webModule.getInfoSync();
  } else if (_env.isKuaiShouMiniProgram) {
    return kuaiShouModule.getInfoSync();
  } else if (_env.isWeChatMiniProgram) {
    return weChatModule.getInfoSync();
  } else if (_env.isByteDanceMicroApp) {
    return bytedanceModule.getInfoSync();
  } else if (_env.isMiniApp) {
    return aliMiniAppModule.getInfoSync();
  } else if (_env.isBaiduSmartProgram) {
    return baiDuModule.getInfoSync();
  } else {
    throw new Error('Uni API：getInfoSync暂不支持');
  }
};
exports.getInfoSync = getInfoSync;
var getInfo = function getInfo(options) {
  if (_env.isWeb) {
    return webModule.getInfo(options);
  } else if (_env.isKuaiShouMiniProgram) {
    return kuaiShouModule.getInfo(options);
  } else if (_env.isWeChatMiniProgram) {
    return weChatModule.getInfo(options);
  } else if (_env.isByteDanceMicroApp) {
    return bytedanceModule.getInfo(options);
  } else if (_env.isMiniApp) {
    return aliMiniAppModule.getInfo(options);
  } else if (_env.isBaiduSmartProgram) {
    return baiDuModule.getInfo(options);
  } else {
    throw new Error('Uni API：getInfo暂不支持');
  }
};
exports.getInfo = getInfo;
var _default = {
  getInfoSync: getInfoSync,
  getInfo: getInfo
};
exports.default = _default;
});

var systemInfo = /*@__PURE__*/getDefaultExportFromCjs(lib);

export { lib as l, systemInfo as s };
